import React from 'react'
import PropTypes from 'prop-types'
import ActivityDialogBody from './ActivityDialogBody'

function ActivityDialogBodyType ({ activityType, component, componentProps, item, ...rest }) {
  if (component) {
    return React.cloneElement(component, {
      ...rest,
      ...(componentProps || {}),
      item
    })
  }

  return <ActivityDialogBody item={item} {...rest} />
}

ActivityDialogBodyType.propTypes = {
  activityType: PropTypes.string,
  component: PropTypes.node,
  componentProps: PropTypes.object,
  item: PropTypes.any
}

export default ActivityDialogBodyType
